import State from '../core/State';
import { OrganizationDetailFragment } from '../generated/graphql';
import initialState from '../initialState';

export const setLastAccessedOrganization = (organization: OrganizationDetailFragment) => (state: State): State => ({
  ...state,
  lastAccessedOrganization: organization,
});

export const updateLastAccessedOrganizationPointBalance = (purchasedPoint: number) => (state: State): State => ({
  ...state,
  lastAccessedOrganization: state.lastAccessedOrganization
    ? {
        ...state.lastAccessedOrganization,
        pointBalance: state.lastAccessedOrganization.pointBalance
          ? state.lastAccessedOrganization.pointBalance + purchasedPoint
          : purchasedPoint,
      }
    : null,
});

export const disposeLastAccessedOrganization = () => (state: State): State => ({
  ...state,
  lastAccessedOrganization: initialState.lastAccessedOrganization,
});
